import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Page } from '@socialbrothers/components/Layout';
import { Card } from '@socialbrothers/components/UI';
import { useResource } from '@socialbrothers/hooks';

import { AdminForm } from '@Components/forms';
import { AdminService, IAdmin } from '@Services/Admin';

export const AdminDetailPage = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data } = useResource<IAdmin>(AdminService, id);

  const label = data?.email ?? t('ADMIN.SINGLE');

  return (
    <Page breadcrumbs={false} title={label}>
      <Card title={t('ADMIN.SINGLE')}>
        <AdminForm />
      </Card>
    </Page>
  );
};
